import React, { useEffect, useState } from "react";
import {
    Grid,
    Typography,
    TextField,
    Button,
    Paper,
    InputAdornment,
    Container,
    Box,
    Divider,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Popover,
    Autocomplete,
    IconButton,
    Popper,
} from "@mui/material";
import hotelBookingImage from "../../../res/Services/HotelBooking/hotelbooking.svg";
import calendarIcon from "../../../res/Services/HotelBooking/calendar.svg";
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import axios from "axios";
import HotelList from './HotelList'; // Import your child component

const HotelBooking = () => {
    const useStyles = () => {
        return {
            searchPaper: {
                p: 3,
                borderRadius: "20px",
                position: "absolute",
                top: "75%",
                left: "50%",
                transform: "translate(-50%, 0)",
                width: "90%",
                display: "flex",
                flexDirection: "column",
                boxShadow: 3,
                overflow: "visible",
            },
            textField: {
                width: { xs: "100%", md: "100%" },
                borderColor: "#D9D9D9CC",
                backgroundColor: "#FFFFFF",
                "& .MuiInputBase-root": {
                    height: { xs: "40px", md: "48px" },
                },
                mt: 1,
            },
        };
    };
    const styles = useStyles();
    const initialState = {
        rooms: 1,
        adults: 1,
        childrenCount: 0,
        childrenAges: null, // Assuming a max of 6 children for initialization
    };
    // State for handling modal and form inputs
    const [open, setOpen] = useState(false);  // To control the Popover visibility
    const [anchorEl, setAnchorEl] = useState(null);
    const [rooms, setRooms] = useState(initialState.rooms);
    const [adults, setAdults] = useState(initialState.adults);
    const [childrenCount, setChildrenCount] = useState(initialState.childrenCount);
    const [childrenAges, setChildrenAges] = useState(initialState.childrenAges);
    const [countries, setCountries] = useState([]);
    const [cities, setCities] = useState([]);
    const [hotels, setHotels] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 0,
        pageSize: 10,
        totalHotels: 0
    });


    const handlePageChange = (newPage) => {
        setPagination(prevState => ({ ...prevState, currentPage: newPage }));
        fetchHotels(selectedCityCode, newPage);
    };

    const [selectedCityCode, setSelectedCityCode] = useState("123875");

    console.log("Selected City Code:", selectedCityCode);

    useEffect(() => {
        // Fetch the country list from the API
        fetch('https://api.ipaisa.co.in/myapp/countries/list', {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('jwtToken')}`,
            },
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.Status.Code === 200) {
                    setCountries(data.CountryList);
                    // Fetch cities for default country IN once the countries are fetched
                    fetchCities('IN');
                }
            })
            .catch((error) => console.error('Error fetching countries:', error));
    }, []);

    useEffect(() => {
        const fetchCities = (countryCode) => {
            fetch('https://api.ipaisa.co.in/myapp/cities/list', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('jwtToken')}`,
                },
                body: JSON.stringify({ CountryCode: countryCode }),
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.Status.Code === 200) {
                        setCities(data.CityList);
                    }
                })
                .catch((error) => console.error('Error fetching cities:', error));
        };

        // Fetch hotels whenever selectedCityCode changes


        // Initial fetch for cities if the country is set (for example, "IN" for India)
        fetchCities('IN');

        // Fetch hotels for the default selectedCityCode
        fetchHotels(selectedCityCode, currentPage);
    }, [selectedCityCode, currentPage]); // Dependency array to trigger on selectedCityCode change

    const fetchCities = (countryCode) => {
        fetch('https://api.ipaisa.co.in/myapp/cities/list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('jwtToken')}`,
            },
            body: JSON.stringify({ CountryCode: countryCode }),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.Status.Code === 200) {
                    setCities(data.CityList);
                }
            })
            .catch((error) => console.error('Error fetching cities:', error));
    };



    // Handle opening the popover
    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);  // Set the element reference
        setOpen(true);  // Open the Popover
    };
    const formatDate = (date) => date.toISOString().split("T")[0];

    // State to store check-in and check-out dates
    const [checkInDate, setCheckInDate] = useState("");
    const [checkOutDate, setCheckOutDate] = useState("");
    useEffect(() => {
        // Get tomorrow's date
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);

        // Get the day after tomorrow's date
        const dayAfterTomorrow = new Date();
        dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);

        // Set the default dates
        setCheckInDate(formatDate(tomorrow));
        setCheckOutDate(formatDate(dayAfterTomorrow));
    }, []);
    const handleResetValues = () => {
        setRooms(initialState.rooms);
        setAdults(initialState.adults);
        setChildrenCount(initialState.childrenCount);
        setChildrenAges(initialState.childrenAges);

        handleClose(initialState.rooms, initialState.children, initialState.childrenCount, initialState.childrenAges, initialState.adults);
    };
    // Handle closing the popover
    const handleClose = () => {
        setOpen(false);  // Close the Popover
    };

    const handleApply = () => {
        // Update the state with the selected values (if needed)
        // This could be used for submitting or saving the values.
        // For now, just logging the current values
        console.log('Applied values:', { rooms, adults, childrenCount, childrenAges });
        handleClose();  // Close the Popover
        // You can also trigger other actions here, e.g., API calls, etc.
    };
    const handleChildrenCountChange = (e) => {
        const count = e.target.value;
        setChildrenCount(count);

        // If there are no children, set childrenAges to null
        if (count === 0) {
            setChildrenAges(null);
        } else {
            // Otherwise, initialize child ages to 0 for the specified count
            setChildrenAges(new Array(count).fill(0));
        }
    };
    const handleChildAgeChange = (index, value) => {
        const updatedAges = [...childrenAges];
        updatedAges[index] = value;
        setChildrenAges(updatedAges);
    };
    const fetchHotels = async (cityCode, page, retry = true) => {
        setLoading(true);
        try {
            const token = sessionStorage.getItem('jwtToken');
            const response = await axios.post(
                "https://api.ipaisa.co.in/myapp/hotels/code-list",
                {
                    CityCode: cityCode,
                    IsDetailedResponse: "false",
                    Page: page,      // Ensure the page parameter is correctly passed
                    PageSize: 10,   // Keeping page size fixed at 10
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            console.log("API Response:", response.data.data);
            setHotels(response.data);

        } catch (error) {
            console.error("API Error:", error);
            // if (retry) {
            //     console.log("Retrying fetchHotels...");
            //     setTimeout(() => fetchHotels(cityCode, page, false), 5000);
            // }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="lg" sx={{ marginTop: "8%", mb: "20%" }}>
            {/* Header */}
            <Grid container sx={{ width: 211, height: 30, alignItems: "center" }}>
                <Typography
                    variant="h4"
                    sx={{
                        fontFamily: "Open Sans",
                        fontWeight: 700,
                        fontSize: "22px",
                        lineHeight: "100%",
                        letterSpacing: "0px",
                        textTransform: "capitalize",
                        color: "#343C6A",
                    }}
                >
                    Hotel Booking
                </Typography>
            </Grid>

            {/* Hero Section */}
            <Box sx={{ mt: "2%", position: "relative" }}>
                <img
                    src={hotelBookingImage}
                    alt="hotelBooking"
                    style={{ width: "100%", position: "relative" }}
                />

                {/* Booking Form */}
                <Paper
                    sx={{
                        p: 3,
                        borderRadius: 2,
                        boxShadow: 3,
                        position: "absolute",
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: "90%",
                        marginTop: "-10%",
                        zIndex: 10, // Ensures it stays above other elements
                        backgroundColor: "#fff"
                    }}
                >


                    <Grid item xs={12}>
                        <Typography sx={{ fontWeight: 600, fontSize: 20 }}>
                            Book Domestic and International Hotels
                        </Typography>
                        <Divider sx={{ width: "100%", mt: 2 }} />
                    </Grid>
                    <Grid container justifyContent="center" mt={2}>
                        {/* Input Fields */}
                        <Grid
                            container
                            spacing={2}
                            sx={{
                                width: 984,
                                height: 75,
                                alignItems: "center",
                            }}
                        >
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontFamily: "Open Sans",
                                        fontWeight: 600,
                                        fontSize: "14px",
                                        lineHeight: "100%",
                                        letterSpacing: "0%",
                                        mb: 1,
                                    }}
                                >
                                    City
                                </Typography>
                                <Autocomplete
                                    options={cities}
                                    getOptionLabel={(option) => option.Name}
                                    value={cities.find((city) => city.Code === selectedCityCode) || null} // Default to Goa
                                    onChange={(event, newValue) => {
                                        if (newValue) {
                                            console.log("Selected City Code:", newValue.Code);
                                            setSelectedCityCode(newValue.Code);
                                            fetchHotels(newValue.Code);
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            sx={{
                                                width: "100%",
                                                "& .MuiOutlinedInput-root": {
                                                    paddingRight: "50px",
                                                },
                                                "& .MuiInputBase-input": {
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    maxWidth: "100%",
                                                    width: "100%",
                                                },
                                            }}
                                        />
                                    )}
                                    fullWidth
                                    ListboxProps={{
                                        sx: {
                                            maxHeight: "200px",
                                            overflowY: "auto",
                                            marginLeft: "16px",
                                            "&::-webkit-scrollbar": {
                                                width: "8px",
                                                backgroundColor: "#e1bee7",
                                            },
                                            "&::-webkit-scrollbar-thumb": {
                                                backgroundColor: "#8a2be2",
                                                borderRadius: "4px",
                                                transition: "background-color 0.3s ease",
                                            },
                                            "&::-webkit-scrollbar-thumb:hover": {
                                                backgroundColor: "#7a1ee2",
                                            },
                                            "&::-webkit-scrollbar-track": {
                                                backgroundColor: "#f1f1f1",
                                            },
                                        },
                                    }}
                                    PopperComponent={(props) => <Popper {...props} placement="bottom-start" />}
                                />



                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="body2" sx={{ fontWeight: 600, fontSize: "14px", mb: 1 }}>
                                    Check In
                                </Typography>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    type="date"
                                    value={checkInDate}
                                    onChange={(e) => setCheckInDate(e.target.value)}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <img src={calendarIcon} alt="calendar" style={{ width: "24px", height: "24px" }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>

                            {/* Check-Out Date */}
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="body2" sx={{ fontWeight: 600, fontSize: "14px", mb: 1 }}>
                                    Check Out
                                </Typography>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    type="date"
                                    value={checkOutDate}
                                    onChange={(e) => setCheckOutDate(e.target.value)}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <img src={calendarIcon} alt="calendar" style={{ width: "24px", height: "24px" }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontFamily: "Open Sans",
                                        fontWeight: 600,
                                        fontSize: "14px",
                                        lineHeight: "100%",
                                        letterSpacing: "0%",
                                        mb: 1,
                                    }}
                                >
                                    Room & Guests
                                </Typography>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    sx={{
                                        cursor: "pointer",
                                    }}
                                    onClick={handleOpen} // Triggers showing the dropdown div
                                    value={`Rooms: ${rooms}, Adults: ${adults}, Children: ${childrenCount}`}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />

                                {/* Popover for Room and Guests */}
                                <Popover
                                    open={open}
                                    anchorEl={anchorEl}
                                    onClose={handleClose}
                                    anchorOrigin={{
                                        vertical: "bottom",
                                        horizontal: "left",
                                    }}
                                    transformOrigin={{
                                        vertical: "top",
                                        horizontal: "left",
                                    }}
                                    PaperProps={{
                                        sx: {
                                            zIndex: 20, // Higher than the Paper
                                            width: '400px',
                                            maxWidth: '95%',
                                            minWidth: '350px',
                                            padding: '10px',
                                            borderRadius: '8px',
                                            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'stretch',
                                        },
                                    }}
                                />

                            </Grid>

                        </Grid>

                        {/* Search Button */}
                        <Grid item xs={12} sx={{ textAlign: "right", mt: 6 }}>
                            <Button
                                variant="contained"
                                sx={{
                                    width: "150px",
                                    height: "48px",
                                    gap: "4px",
                                    borderRadius: "4px",
                                    padding: "8px 24px",
                                    backgroundColor: "#027BFE",
                                    "&:hover": {
                                        backgroundColor: "#027BFE",
                                    },
                                }}
                            >
                                <Typography noWrap sx={{ fontFamily: "Open Sans", fontWeight: 200, fontSize: "14px", lineHeight: "100%" }}>
                                    Search Hotel
                                </Typography>
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
                <div>
                    {loading && <p>Loading...</p>}
                    <HotelList
                        hotels={hotels}
                        pagination={pagination}
                        onPageChange={handlePageChange}
                    />
                </div>
            </Box>
        </Container>
    );
};

export default HotelBooking;
